import { Location } from '../models/location';
import { Brand } from './brand';
import { Customer } from './customer';
import moment from 'moment-timezone';

export interface Order {
  id: string;
  platformId: string;
  stationVideos: StationVideo[];
  phaseStatuses: OrderPhaseStatus[];
  location: Location;
  brand: Brand;
  price: number;
  customer: Customer;
  items: OrderItem[];
  score?: number;
  notes?: string;
}

export interface StationVideo {
  stationId: string;
  stationName: string;
  stationLabel: string;
  state: string;
  videoUrl: string;
  recognitionData: RecognitionObject[];
}
export interface RecognitionObject {
  objects: string[];
  startTime: string;
  keyframesTime: null | string[];
  endTime: string;
  dateProcessed: string;
  correctOrder: boolean;
}

export interface OrderItem {
  name: string;
  quantity: number;
  modifiers: [OrderItemModifier];
  notes: string;
}

export interface OrderItemModifier {
  name: string;
  options: string[];
  choice: string;
  quantity: number;
}

export interface OrderPhaseStatus {
  phase: OrderPhase;
  started: null | String;
  ended: null | String;
}

export interface OrderPhase {
  name: string;
}

export const getOrderDate = (order: Order): any => {
  const phaseStatuses = order.phaseStatuses;
  const now = moment();

  if (phaseStatuses.length === 0) {
    return now;
  }

  // todo: use location.timezoneOffset
  if (phaseStatuses.length === 1 && phaseStatuses[0].started) {
    return (moment(phaseStatuses[0].started.toString())) || now;
  }

  const dateString = phaseStatuses.slice().sort((a, b) => {
    const aStartedDate = (a.started) ? (moment(a.started.toString())).valueOf() : 0
    const bStartedDate = (b.started) ? (moment(b.started.toString())).valueOf() : 0
    return aStartedDate - bStartedDate;
  })[0].started
  
  const outputDate = (dateString ? moment.utc(dateString.toString()).subtract(order.location.timezoneOffset, 'hours') : now).utcOffset(order.location.timezoneOffset);
  return outputDate;
};

export const computeOrderDuration = (order: Order): number => {
  if (order.phaseStatuses.length === 0) {
    return 0;
  }

  const now = new Date();
  let earliestTime: Date | null = null;
  let latestTime = new Date(0);

  order.phaseStatuses.forEach((phaseStatus) => {
    if (phaseStatus.started === null || phaseStatus.ended === null) {
      latestTime = now;
    } else {
      if (earliestTime === null || (new Date(phaseStatus.started.replace(/-/g, "/"))) < earliestTime) {
        earliestTime = new Date(phaseStatus.started.replace(/-/g, "/"));
      }

      if (new Date(phaseStatus.ended.replace(/-/g, "/")) > latestTime) {
        latestTime = new Date(phaseStatus.ended.replace(/-/g, "/"));
      }
    }
  });

  if (!earliestTime) earliestTime = now;

  return Math.max(0, latestTime.valueOf() - earliestTime.valueOf());
};

export const computeMaxOrderDuration = (orders: Order[]): number => {
  return Math.max(...orders.map(computeOrderDuration));
};
